import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { fade, openClose } from '@core/animations/animations';
import { Tenant } from '@models/matter';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MODAL_DATA } from 'src/app/ui/modal/modal-data.token';

@UntilDestroy()
@Component({
	selector: 'app-tenants-modal',
	templateUrl: './tenants-modal.component.html',
	animations: [fade(), openClose()],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TenantsModalComponent {
	tenant = inject(MODAL_DATA) as Tenant;
}
